import client from './client';

export type TodayCalendarState = 'events' | 'empty' | 'not_connected';

export interface TodayCalendarEvent {
  id: string;
  title: string;
  start: string;
  end?: string | null;
  all_day: boolean;
}

export interface TodayCalendarResponse {
  state: TodayCalendarState;
  events: TodayCalendarEvent[];
}

export async function getTodayCalendar(
  timeZone?: string | null,
  options: { signal?: AbortSignal } = {},
): Promise<TodayCalendarResponse> {
  const zone = (timeZone || '').trim();
  const { data } = await client.get<TodayCalendarResponse>('/today/calendar', {
    params: zone ? { time_zone: zone } : undefined,
    signal: options.signal,
  });
  return {
    state: data?.state === 'events' || data?.state === 'empty' ? data.state : 'not_connected',
    events: Array.isArray(data?.events) ? data.events : [],
  };
}
